/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-undef */
/* eslint-disable max-len */
import React from 'react';

import { useTranslation } from 'react-i18next';
import Footer from '../Footer';
import { FOOTER_NAVBAR_SCHEMA } from '../../schemas/navbar_schema';

function MainFooter() {
  const { t } = useTranslation();

  return (
    <Footer
      title={FOOTER_NAVBAR_SCHEMA.home.text}
      desc={t('subTitle')}
      links={FOOTER_NAVBAR_SCHEMA.items}
    />
  );
}

export default MainFooter;
